<template>
  <div
    class="race-list-header"
    :class="{
      'race-list-header--for-pc': forPc,
      'race-list-header--show-timetable': showTimetable,
    }"
  >
    <race-list-header-parts
      class="race-list-header__race-data"
      :class="{ 'race-list-header__race-data--hidden': showInformation }"
      :round="currentChampionship ? currentChampionship.round : undefined"
      :raceDate="currentChampionship ? currentChampionship.raceDate : ''"
      :raceVenue="currentChampionship ? currentChampionship.circuitName[$i18n.locale] || '' : ''"
      :showTimetable="showTimetable"
    />

    <race-list-view-button-parts
      v-if="!showInformation && !showTimetable"
      @onClickViewTimetable="handleViewTimetableClicked"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'
import RaceListHeaderParts from '@/components/RaceListPage/RaceListPane/parts/RaceListHeaderParts.vue'
import RaceListViewButtonParts from '@/components/RaceListPage/RaceListPane/parts/RaceListViewButtonParts.vue'
import ChampionshipDocument from '@/store/stores/collectionModule/documents/championship/ChampionshipDocument'

export default defineComponent({
  name: 'RaceListHeaderSection',
  components: {
    RaceListViewButtonParts,
    RaceListHeaderParts,
  },
  props: {
    currentChampionship: {
      type: Object as PropType<ChampionshipDocument>,
      required: true,
    },
    showInformation: {
      type: Boolean,
      default: false,
    },
    showTimetable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const forPc = DeviceInfo.isForPC()
    const handleViewTimetableClicked = () => {
      emit('onClickViewTimetable')
    }
    const handleCloseClicked = () => {
      emit('onClickClose')
    }
    return {
      forPc,
      handleViewTimetableClicked,
      handleCloseClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.race-list-header {
  width: 100%;

  &__race-data {
    transition: opacity 0.3s ease;

    &--hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  &--for-pc {
    &.race-list-header--show-timetable {
      .race-list-header__race-data {
        width: 100%;
      }
    }
  }
}
</style>
